<script setup>
/* Ét produkt med de billigste butikker. */
import { computed } from 'vue';

const props = defineProps({ data: { type: Object, required: true } });

const vare = computed(() => props.data.vare);
const billede = computed(() => (vare.value?.images?.length ? `/images/${vare.value.images[0].id}` : null));

function kr(v) {
    const n = Number(v);
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK', maximumFractionDigits: 0 }).format(n);
}
</script>

<template>
    <p v-if="!vare" class="text-secondary small mb-0">Ingen vare valgt.</p>

    <div v-else class="produktkort">
        <div class="produktkort__top">
            <!--
                MAALT 16/10-2026: billedet vises i 120px og blev hentet i 160 —
                faktor 1,33. Paa en 2x-skaerm er det under halv oploesning.
                De andre kort i appen henter 2x eller mere: ProductListRow 160
                til 80, DagensFund 160 til 56, build-siden 160 til 52. Kun det
                her kort og "Se ogsaa" laa under.
            -->
            <img
                v-if="billede"
                :src="`${billede}?w=160`"
                :srcset="`${billede}?w=160 1x, ${billede}?w=320 2x`"
                :alt="vare.display_name"
                width="120"
                height="120"
                loading="lazy"
                decoding="async"
            />
            <div>
                <h3 class="h6 mb-1">
                    <a :href="vare.route_to_productdetail">{{ vare.display_name || vare.model_short_name }}</a>
                </h3>
                <p v-if="vare.brand?.name" class="small text-secondary mb-0">{{ vare.brand.name }}</p>
            </div>
        </div>

        <table v-if="data.priser.length" class="table table-sm mt-3 mb-0">
            <tbody>
                <tr v-for="(p, i) in data.priser" :key="i">
                    <td>{{ p.butik }}</td>
                    <td class="text-secondary small">{{ p.lager }}</td>
                    <td class="text-end fw-semibold text-nowrap">
                        <a v-if="p.link" :href="p.link" rel="nofollow sponsored" target="_blank">{{ kr(p.pris) }}</a>
                        <span v-else>{{ kr(p.pris) }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
        <p v-else class="text-secondary small mt-2 mb-0">Ingen aktive priser lige nu.</p>
    </div>
</template>

<style scoped>
.produktkort { border: 1px solid var(--pc-border); border-radius: var(--pc-radius); padding: 1rem; }
.produktkort__top { display: flex; gap: 1rem; align-items: center; }
.produktkort__top img { object-fit: contain; }
</style>
